module.exports = require("multimatch");